<template>
  <UiSectionCard
    v-bind="$attrs"
    class="ui-compact-section-card"
    :title="$t(title)"
    :icon="icon"
    :shadow="shadow"
    :body-style="bodyStyle"
    v-on="$listeners"
  >
    <template v-if="hasTitleSlot" #title>
      <slot name="title" />
    </template>
    <template v-if="hasActionsSlot" #actions>
      <slot name="actions" />
    </template>
    <slot />
  </UiSectionCard>
</template>

<script>
export default {
  name: 'UiCompactSectionCard',
  inheritAttrs: false,
  props: {
    title: { type: String, default: '' },
    icon: { type: [String, Array, Object], default: '' },
    shadow: { type: String, default: 'never' },
    bodyStyle: { type: Object, default: () => ({}) }
  },
  computed: {
    hasTitleSlot () {
      return Boolean(this.$slots.title || this.$scopedSlots.title)
    },
    hasActionsSlot () {
      return Boolean(this.$slots.actions || this.$scopedSlots.actions)
    }
  }
}
</script>

<style lang="scss" scoped>
/*
 * 轻量配置分区：复原旧版设置分组的紧凑层级。
 * 参数源自历史提交 51436a1，避免与普通分区标题争夺注意力。
 */
.ui-compact-section-card.ui-section-card {
  overflow: hidden;
  border: 1px solid var(--el-border-color-base);
  border-radius: 8px;
  background: var(--el-color-white);
  box-shadow: 0 1px 3px rgba(var(--ui-color-black-rgb), .08);
  transition: border-color .18s ease, box-shadow .18s ease;
}

.ui-compact-section-card.ui-section-card:hover {
  border-color: var(--el-color-primary-light-2);
  box-shadow: 0 4px 12px rgba(var(--ui-color-black-rgb), .11);
}

.ui-compact-section-card.ui-section-card ::v-deep > .el-card__header {
  height: 42px !important;
  min-height: 42px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-right: var(--ui-space-md) !important;
  padding-left: var(--ui-space-md) !important;
  background: linear-gradient(
    180deg,
    var(--app-header-gradient-start) 0%,
    var(--app-header-gradient-end) 100%
  ) !important;
}

.ui-compact-section-card.ui-section-card ::v-deep > .el-card__header .ui-section-title {
  padding-left: calc(2px + var(--ui-space-sm)) !important;
  color: var(--el-text-color-primary);
  font-size: var(--ui-font-size-body) !important;
  font-weight: 600;
  line-height: 42px;
}

.ui-compact-section-card.ui-section-card ::v-deep > .el-card__header .ui-section-title:not(.has-icon)::before {
  display: block !important;
  width: 2px;
  height: 12px;
  background: var(--ui-color-primary);
}

.ui-compact-section-card.ui-section-card ::v-deep > .el-card__header .ui-section-title.has-icon {
  padding-left: 0 !important;
}

.ui-compact-section-card.ui-section-card ::v-deep > .el-card__header .ui-section-title > i {
  font-size: var(--ui-font-size-body) !important;
}

.ui-compact-section-card.ui-section-card ::v-deep > .el-card__body {
  padding: 14px var(--ui-space-md) var(--ui-space-md) !important;
}
</style>
